import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { currencyFormatter, percentageFormatter } from '../../../common/utils/helpers';
import Table from 'antd/lib/table';
import { ResponsiveTable } from '../../../common/components/data-display';


const Column = Table.Column;

@translate()
export default class DashboardTableSection extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        header: PropTypes.string,
        sectionData: PropTypes.array.isRequired,
    };


    render() {
        const {
            t,
            header,
            sectionData,
        } = this.props;




        return (
            <ResponsiveTable
                dataSource={sectionData}
                pagination={false}
                rowClassName={(record) => record.style ? `section-row-${record.style}` : ``}
                title={() => header}>
                <Column
                    title={''}
                    className='dashboard-col-5'
                    dataIndex="title"
                    key="title"
                    render={value => t(value)}
                />
                <Column
                    title={t('Dnes')}
                    className='dashboard-col-5'
                    dataIndex="today"
                    key="today"
                />
                <Column
                    title={t('Včera')}
                    className='dashboard-col-5'
                    dataIndex="yesterday"
                    key="yesterday"
                />
                <Column
                    title={t('Tento mesiac')}
                    className='dashboard-col-5'
                    dataIndex="thisMonth"
                    key="thisMonth"
                />
                <Column
                    title={t('Minulý mesiac')}
                    className='dashboard-col-5'
                    dataIndex="lastMonth"
                    key="lastMonth"
                />
            </ResponsiveTable>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/admin-dashboard/components/DashboardTableSection.js